import React, { useMemo } from "react";
import {
  DASHBOARD_PERIOD_LABELS,
  DASHBOARD_PERIOD_PRESETS,
} from "../constants/dashboardPeriods";
import { DashboardPeriodPreset } from "../types/ownerDashboard.types";
import DashboardSelect from "./DashboardSelect";

interface DashboardPeriodFilterProps {
  value: DashboardPeriodPreset;
  onChange: (period: DashboardPeriodPreset) => void;
  label?: string;
  compact?: boolean;
  presets?: DashboardPeriodPreset[];
}

export default function DashboardPeriodFilter({
  value,
  onChange,
  label = "Período",
  compact = false,
  presets = DASHBOARD_PERIOD_PRESETS,
}: DashboardPeriodFilterProps) {
  const options = useMemo(
    () =>
      presets.map((preset) => ({
        value: preset,
        label: DASHBOARD_PERIOD_LABELS[preset],
      })),
    [presets]
  );

  return (
    <div className={compact ? "w-full sm:w-auto sm:min-w-[180px]" : "w-full sm:min-w-[200px]"}>
      <DashboardSelect
        label={label}
        value={value}
        options={options}
        onChange={(nextValue) => onChange(nextValue as DashboardPeriodPreset)}
      />
    </div>
  );
}
